import {
	Button,
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@monbits/ui";
import { BookOpen, Copy } from "lucide-react";
import type * as React from "react";
import useActiveMerchantId from "src/hooks/use-merchant-id";
import copyToClipboard from "src/utils/copy-to-clipboard";

interface Props {
	openPopupFunc: (title: string, desc: string) => void;
}

const DevelopersSection: React.FC<Props> = ({ openPopupFunc }) => {
	const { merchantId } = useActiveMerchantId();

	const handleCopy = () => {
		if (merchantId) {
			copyToClipboard(merchantId, openPopupFunc);
		}
	};

	return (
		<Card>
			<CardHeader className="pb-2">
				<div className="flex items-start justify-between gap-3">
					<div className="space-y-1">
						<CardTitle className="text-base font-medium">Identity</CardTitle>
						<CardDescription className="text-xs">
							The merchant ID is included in every API call you make.
						</CardDescription>
					</div>
					<Button asChild variant="outline" size="sm" className="flex-shrink-0">
						<a
							href="https://api-docs.pay.monbits.com"
							target="_blank"
							rel="noopener noreferrer"
						>
							<BookOpen className="mr-2 h-3.5 w-3.5" />
							API reference
						</a>
					</Button>
				</div>
			</CardHeader>
			<CardContent>
				<p className="mb-2 text-[11px] font-medium uppercase tracking-[0.16em] text-muted-foreground">
					Merchant ID
				</p>
				<button
					type="button"
					aria-label="Copy merchant ID"
					className="group flex w-full items-center gap-3 rounded-lg border border-border bg-muted/60 p-3 text-left transition-colors hover:bg-muted"
					onClick={handleCopy}
				>
					<code className="flex-1 break-all font-mono text-sm">
						{merchantId}
					</code>
					<Copy
						aria-hidden="true"
						className="h-3.5 w-3.5 flex-shrink-0 text-muted-foreground transition-colors group-hover:text-primary"
					/>
				</button>
			</CardContent>
		</Card>
	);
};

export default DevelopersSection;
